<div class="case-plan-status-banner" *ngIf="hasPendingItems">
  <svg-icon
    src="/assets/icon/icon-warning-circle-sm.svg"
    class="icon s-16 case-plan-status-banner__icon"
    aria-label="Warning"></svg-icon>
  <div class="case-plan-status-banner__text">
    <p
      class="case-plan-status-banner__message"
      *ngIf="status?.hasPendingHardStop">
      {{ templateName || 'This template' }} is assigned to this student. It sets
      {{ hardStopItemNames.length }} questionnaires as Hard Stop:
      {{ hardStopItemNames.join(', ') }}. Add New Behavior stays disabled until
      these questionnaires are completed.
    </p>
    <p
      class="case-plan-status-banner__message"
      *ngIf="status?.hasPendingRequired">
      {{ templateName || 'This template' }} is assigned to this student. It sets
      {{ requiredItemNames.length }} questionnaires as Required:
      {{ requiredItemNames.join(', ') }}. Add New Behavior stays disabled until
      these questionnaires are completed.
    </p>
  </div>
</div>
<div
  class="case-plan-status-banner"
  *ngIf="isQuestionnaireValid && draftBehaviors.length > 0">
  <svg-icon
    src="/assets/icon/icon-warning-circle-sm.svg"
    class="icon s-16 case-plan-status-banner__icon"
    aria-label="Warning"></svg-icon>
  <div class="case-plan-status-banner__text">
    <p class="case-plan-status-banner__message">
      These behaviors stay in Draft until their Hard Stop/Required sections are
      filled:
    </p>
    <ul class="case-plan-status-banner__behavior-list">
      <li
        class="case-plan-status-banner__behavior-line"
        *ngFor="let behavior of draftBehaviors; trackBy: trackByBehaviorId"
        [title]="
          behavior.behaviorName + ': ' + behavior.pendingItemNames.join(', ')
        ">
        {{ behavior.behaviorName }}:
        {{ behavior.pendingItemNames.join(', ') }}
      </li>
    </ul>
  </div>
</div>
